export const messages = {
  page: {
    title: {
      id: 'patientKioskQuestionnaires.Page.Title',
      defaultMessage: '-def-Questionnaires',
    },
    zeroState: {
      id: 'patientKioskQuestionnaires.Page.ZeroState',
      defaultMessage: '-def-There are no active questionnaires available.',
    },
  },
};
